import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const SESSION_TIMEOUT_MINUTES = 30; // Set your timeout here

const SessionTimeoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  const { logout } = useAuth();
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Reset timer on user activity
  const resetTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      logout(); // Use the global logout for consistency
      // Optionally, you can still navigate or show a message
      // navigate("/login", { replace: true, state: { sessionExpired: true } });
    }, SESSION_TIMEOUT_MINUTES * 60 * 1000);
  };

  useEffect(() => {
    // Entrance/exam-center screens are a separate kiosk session with their
    // own idle handling (useIdleTimeout -> /entrance-login). Without this
    // skip, this admin/staff timer fired logout() there too and hard-
    // redirected to /login (the admin panel) instead of the exam login.
    if (pathname.startsWith("/entrance")) return;

    // List of events that indicate user activity
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer(); // Start timer on mount

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line
  }, [pathname.startsWith("/entrance")]);

  return <>{children}</>;
};

export default SessionTimeoutProvider; 